import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../../app.reducers';
import { Observable } from 'rxjs';
import {
  getAdminProperty,
} from '../../admin-store/admin.selectors';
import {
  ClearAdminImportRequestsAction,
  LoadAdminPropertyAction,
} from '../../admin-store';
import { ActivatedRoute, Params } from '@angular/router';
import { Property } from '../../../property/shared/models';
import { Workspace } from 'app/internal/shared';
import { getWorkspaceSettings } from 'app/internal/workspace/workspace-store/workspace.selectors';

@Component({
  templateUrl: './admin-property.component.html',
  styleUrls: ['./admin-property.component.scss'],
  standalone: false
})

export class AdminPropertyComponent implements OnInit, OnDestroy {

  property$: Observable<Property>;
  workspace$: Observable<Workspace>;
  propertyId: string;

  constructor(private store: Store<AppState>,
    private route: ActivatedRoute) {
    this.property$ = this.store.pipe(select(getAdminProperty));
    this.workspace$ = this.store.pipe(select(getWorkspaceSettings));
  }

  ngOnInit() {
    this.route.params.subscribe(
      (params: Params) => {
        this.propertyId = params['id'];
        this.store.dispatch(new LoadAdminPropertyAction(this.propertyId));
      }
    );
  }

  ngOnDestroy() {
    this.store.dispatch(new ClearAdminImportRequestsAction());
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onSubmit(fiscalYear: number) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const propertyId = this.propertyId;
    // this.store.dispatch(new ProcessAdminImportRequestAction({importRequestId, fiscalYear}))
  }
}
